import React from 'react'
import { Link, Redirect } from 'react-static'
import styled from 'styled-components'

import { adminRemove } from '../../firebase'

import AdminSuccess from './AdminSuccess'

const Wrapper = styled.div`
  .title.is-5 {
    text-transform: none;
  }

  &.column {
    text-align: center;

    .box {
      margin: 0 auto;
      max-width: 38em;
      padding: 2em;
    }

    .field.is-grouped {
      justify-content: center;
      margin-top: 1.5em;
    }
  }
`

export default class AdminRemove extends React.Component {
  constructor () {
    super()
    this.state= {
      success: false,
      successRedirect: false,
      successRedirectUrl: '',
    }
    this.remove = this.remove.bind(this)
    this.showSuccessModal = this.showSuccessModal.bind(this)
    this.successRedirect = this.successRedirect.bind(this)
  }

  remove () {
    adminRemove(this.props.refUrl, this.showSuccessModal, this.successRedirect, this.props.template)
  }

  showSuccessModal (cb, url) {
    this.setState({ success: true }, () => {
      cb(url)
    })
  }

  successRedirect (url) {
    setTimeout(() => {
      this.setState({
        successRedirect: true,
        successRedirectUrl: url,
      })
    }, 800)
  }

  render () {
    const { template, itemTitle } = this.props
    const { success, successRedirect, successRedirectUrl } = this.state
    return (
      successRedirect
        ? <Redirect to={`/admin/${successRedirectUrl}`} />
        : <Wrapper className="column">
          <div className="box is-block">
            <h5 className="subtitle is-5">Are you sure you want to delete <strong>{itemTitle}</strong>?</h5>
            <div className="field is-grouped">
              <div className="control">
                <button className="button is-danger" onClick={this.remove}>Confirm</button>
              </div>
              <div className="control">
                <Link to={`/admin/${template}`} className="button is-link" >Cancel</Link>
              </div>
            </div>
          </div>
          <AdminSuccess
            type="Deletion"
            className={success ? 'modal is-active' : 'modal'} />
        </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminRemove.js